var map = {
	"./consultorio-01.69dcb74b.JPG": 921,
	"./consultorio-02.c527e480.JPG": 293,
	"./consultorio-03.a779bb1c.JPG": 992,
	"./consultorio-04.5198b973.JPG": 534,
	"./consultorio-05.56f7687b.JPG": 323,
	"./consultorio-06.686e3435.JPG": 63,
	"./consultorio-07.b620e0b0.JPG": 479,
	"./results-01.jpg": 424,
	"./results-02.jpg": 999,
	"./results-03.jpg": 346,
	"./results-04.jpg": 937,
	"./results-05.jpg": 212,
	"./results-06.jpg": 259,
	"./results-07.jpg": 446,
	"./results-08.jpg": 453,
	"./results-09.jpg": 0
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 862;